"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.map = void 0;
/**
 * Performance optimized version of `Array.prototype.map` method.
 *
 * Creates a new array populated with the results of calling a provided function
 * on every element in the calling array.
 *
 * @see https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/map
 *
 * **Limitations against native implementation**:
 *
 * - **`callback` is invoked for all indexes of the array**,
 * (not only for indexes with assigned values like native filter implementation), see example.
 * - Doesn't accept the `scope` as last argument.
 *
 * @param {Array} array - Input array.
 * @param {Function} callback - Function that is called for every element of arr.
 * Each time callback executes, the returned value is added to output array.
 *
 * @return {Array} with mapped results.
 *
 * @example
 * import { map } from '@24i/appstage-shared-perf-utils/dist/array';
 *
 * const array = [1, 4, 9, 16];
 *
 * // const mappedArray = array.map(x => x * 2); // slower native solution
 * const mappedArray = map(array, x => x * 2);   // faster
 *
 * console.log(mappedArray);
 * // expected output: Array [2, 8, 18, 32]
 *
 * @example
 * import { map } from '@24i/appstage-shared-perf-utils/dist/array';
 *
 * const array = [1, , 2].map(x => x * x) // [ 1, , 4 ]
 *
 * const nativeResult = array.map(x => x * x);
 * console.log(nativeResult); // [ 1, , 4 ] // keeps hole in array
 *
 * const customResult = map(array, x => x * x);
 * console.log(customResult); // [ 1, NaN , 4 ] NaN? -> undefined * undefined = NaN
 */
const map = (array, callback) => {
    const len = array.length;
    const output = new Array(len);
    for (let i = 0; i < len; i++) {
        output[i] = callback(array[i], i, array);
    }
    return output;
};
exports.map = map;
